"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Subject_1 = require("rxjs/Subject");
var noop_1 = require("rxjs/util/noop");
var model_1 = require("../../model");
var authentication_service_1 = require("../authentication.service");
var cookie_service_1 = require("../cookie-service");
var auth_settings_config_1 = require("./auth-settings.config");
var login_responses_enum_1 = require("./login-responses.enum");
var http_url_standard_encoding_spec_1 = require("../util/http-url-standard-encoding-spec");
var identity_1 = require("rxjs/util/identity");
/**
 * Http implementation of AuthenticationService
 * @author gnuni.gevorgyan
 */
var HttpAuthenticationService = /** @class */ (function (_super) {
    __extends(HttpAuthenticationService, _super);
    function HttpAuthenticationService(http, appProperties, cookieService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.appProperties = appProperties;
        _this.cookieService = cookieService;
        _this.redirectUrl = '';
        _this.loggedOn = new ReplaySubject_1.ReplaySubject(1);
        _this.loggedOnAsGuest = new ReplaySubject_1.ReplaySubject(1);
        _this.authServiceUrl = new ReplaySubject_1.ReplaySubject(1);
        _this.userData = new ReplaySubject_1.ReplaySubject(1);
        _this.destroySubject$ = new Subject_1.Subject();
        _this.appProperties
            .getProperty(auth_settings_config_1.AuthSettings.OAUTH_SERVICE_URL_KEY)
            .then(function (url) {
            _this.authServiceUrl.next(url);
            _this.authServiceUrl.complete();
        })
            .catch(console.error);
        _this.username = _this.getUsername();
        _this.checkToken();
        return _this;
    }
    HttpAuthenticationService_1 = HttpAuthenticationService;
    HttpAuthenticationService.getInstance = function (http, appProperties, cookieService, 
    // tslint:disable-next-line:no-any
    _) {
        if (this._instance === undefined) {
            this._instance = new HttpAuthenticationService_1(http, appProperties, cookieService);
        }
        return this._instance;
    };
    HttpAuthenticationService.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    /**
     * @returns current user data
     */
    HttpAuthenticationService.prototype.getUserData = function () {
        return this.userData.asObservable();
    };
    /**
     * @returns true if user is logged on
     */
    HttpAuthenticationService.prototype.isLoggedOn = function () {
        return this.loggedOn.asObservable();
    };
    /**
     * Login User
     */
    HttpAuthenticationService.prototype.login = function (username, password) {
        var _this = this;
        var httpParams = new http_1.HttpParams({
            encoder: new http_url_standard_encoding_spec_1.HttpUrlStandardEncodingCodec(),
        })
            .set('grant_type', 'password')
            .set('username', username)
            .set('password', password);
        this.setUsername(username);
        var options = this.oauthClientHeaders();
        return this.authServiceUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .post(url + auth_settings_config_1.AuthSettings.OAUTH_SERVICE_TOKEN_ENDPOINT, httpParams, options)
                .pipe(operators_1.switchMap(function (response) {
                if (response.status === 200) {
                    var body = response.body;
                    while (_this.cookieService.check(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME)) {
                        _this.cookieService.delete(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME, '/');
                    }
                    _this.cookieService.set(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME, body['access_token'], undefined, '/');
                    if (body['isNeedVerification']) {
                        return of_1.of(new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.NEED_VERIFICATION, '', [], body['verificationType']));
                    }
                    return _this.userDataObservable().pipe(operators_1.map(function () {
                        _this.loggedOn.next(true);
                        return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.SUCCESS);
                    }));
                }
                else {
                    return of_1.of(new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.FAILED, 'auth_bad_credentials'));
                }
            }));
        }), operators_1.catchError(function (httpErrorResponse) {
            return of_1.of(_this.handleLoginError(httpErrorResponse.error, httpErrorResponse.status));
        }));
    };
    HttpAuthenticationService.prototype.verifyCode = function (code, type) {
        var _this = this;
        var options = this.oauthClientHeaders();
        var params = new http_1.HttpParams()
            .set('verificationCode', code)
            .set('userLogin', this.getUsername());
        if (type) {
            params = params.set('type', type);
        }
        var accessToken = this.cookieService.get(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME);
        if (accessToken) {
            params = params.set('token', accessToken);
        }
        options['params'] = params;
        return this.authServiceUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + auth_settings_config_1.AuthSettings.VERIFY_CODE, options);
        }), operators_1.switchMap(function (response) {
            if (response.body) {
                _this.loggedOn.next(true);
                return _this.userDataObservable().pipe(operators_1.map(function () { return response.body; }));
            }
            return of_1.of(response.body);
        }));
    };
    HttpAuthenticationService.prototype.resend = function (type) {
        var _this = this;
        var username = this.getUsername();
        var options = this.oauthClientHeaders();
        var params = new http_1.HttpParams()
            .set('userLogin', username)
            .set('type', type);
        var accessToken = this.cookieService.get(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME);
        if (accessToken) {
            params = params.set('token', accessToken);
        }
        options['params'] = params;
        return this.authServiceUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + auth_settings_config_1.AuthSettings.RESEND, undefined, options);
        }), operators_1.map(function () { return true; }), operators_1.catchError(function () { return of_1.of(false); }));
    };
    HttpAuthenticationService.prototype.loginAsGuest = function () {
        return this.login(auth_settings_config_1.AuthSettings.GUEST_USER_NAME, auth_settings_config_1.AuthSettings.GUEST_PASSWORD);
    };
    /**
     * @inheritDoc
     */
    HttpAuthenticationService.prototype.logout = function (withoutRequest) {
        var _this = this;
        if (withoutRequest === void 0) { withoutRequest = false; }
        if (!withoutRequest) {
            this.authServiceUrl
                .pipe(operators_1.switchMap(function (url) {
                return _this.http.get(url + auth_settings_config_1.AuthSettings.OAUTH_SERVICE_LOGOUT_ENDPOINT);
            }), operators_1.map(function () {
                _this.cookieService.delete(auth_settings_config_1.AuthSettings.IS_SAML_USER, '/');
                _this.cookieService.delete(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME, '/');
                localStorage.removeItem(auth_settings_config_1.AuthSettings.CSRF_TOKEN_KEY_NAME);
            }), operators_1.first())
                .subscribe(noop_1.noop, function (err) { return console.error(err); });
        }
        this.loggedOn.next(false);
    };
    HttpAuthenticationService.prototype.isLoggedOnAsGuestUser = function () {
        return this.loggedOnAsGuest.asObservable();
    };
    HttpAuthenticationService.prototype.checkToken = function () {
        var _this = this;
        this.checkTokenValidity();
        this.loggedOn
            .pipe(operators_1.filter(identity_1.identity), operators_1.mergeMap(function () { return _this.userDataObservable(); }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, function (err) { return console.error(err); });
    };
    HttpAuthenticationService.prototype.checkTokenValidity = function () {
        var _this = this;
        var httpParams = new http_1.HttpParams();
        var accessToken = this.cookieService.get(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME);
        if (accessToken) {
            httpParams = httpParams.set('token', accessToken);
        }
        var options = this.oauthClientHeaders();
        this.authServiceUrl
            .pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + auth_settings_config_1.AuthSettings.OAUTH_SERVICE_CHECK_TOKEN_ENDPOINT, httpParams, options);
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (response) {
            _this.loggedOn.next(true);
            var data = response.body;
            _this.checkIfUserIsGuest(Number(data['user_name']));
        }, function () {
            if (accessToken) {
                _this.cookieService.delete(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME);
            }
            _this.loggedOn.next(false);
            _this.checkIfUserIsGuest(undefined);
        });
    };
    HttpAuthenticationService.prototype.checkIfUserIsGuest = function (userId) {
        this.loggedOnAsGuest.next(userId === auth_settings_config_1.AuthSettings.GUEST_USER_ID);
    };
    HttpAuthenticationService.prototype.userDataObservable = function () {
        var _this = this;
        return this.authServiceUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + auth_settings_config_1.AuthSettings.OAUTH_SERVICE_USERDATA_ENDPOINT, {
                observe: 'response',
            });
        }), operators_1.map(function (resp) {
            var userData = new model_1.UserData();
            if (resp.status === 200) {
                var data = resp.body;
                userData.fullName = data['userName'];
                userData.userId = Number(data['userId']);
                userData.username = _this.getUsername();
                _this.checkIfUserIsGuest(userData.userId);
            }
            _this.userData.next(userData);
        }));
    };
    HttpAuthenticationService.prototype.oauthClientHeaders = function () {
        var encoded = btoa(auth_settings_config_1.AuthSettings.CLIENT_ID + ':' + auth_settings_config_1.AuthSettings.CLIENT_SECRET);
        var headers = new http_1.HttpHeaders()
            .append('Authorization', 'Basic ' + encoded)
            .append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
        return { headers: headers, observe: 'response' };
    };
    HttpAuthenticationService.prototype.handleLoginError = function (errorObject, status) {
        if (status === 400 && errorObject['error'] === 'invalid_grant') {
            if (errorObject['error_description'] ===
                'User credentials have expired') {
                return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.EXPIRED, 'auth_expired_credentials');
            }
            if (errorObject['error_description'] === 'User account is locked') {
                return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.UM_LOCK, 'auth_user_lock');
            }
        }
        else if (status === 403) {
            if (errorObject['error'] !== 'user_block') {
                throw new Error('Unknown error type ' + errorObject['error']);
            }
            return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.BLOCK, 'auth_user_block', [], undefined, errorObject['error_message_lastmodified'], errorObject['lockTimeInMinutes']);
        }
        return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.FAILED, 'auth_bad_credentials');
    };
    HttpAuthenticationService.prototype.setUsername = function (username) {
        this.username = username;
        localStorage.setItem(auth_settings_config_1.AuthSettings.USERNAME_KEY_NAME, username);
    };
    HttpAuthenticationService.prototype.getUsername = function () {
        return (this.username ||
            localStorage.getItem(auth_settings_config_1.AuthSettings.USERNAME_KEY_NAME));
    };
    HttpAuthenticationService._instance = undefined;
    HttpAuthenticationService = HttpAuthenticationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            cookie_service_1.CookieService])
    ], HttpAuthenticationService);
    return HttpAuthenticationService;
    var HttpAuthenticationService_1;
}(authentication_service_1.AuthenticationService));
exports.HttpAuthenticationService = HttpAuthenticationService;
//# sourceMappingURL=http-authentication.service.js.map